

export const API_URL = process.env.REACT_APP_API_URL;
export const IMAGE_HOST_URL = process.env.REACT_APP_IMAGE_HOST_URL;
export const ENVIRONMENT_LEVEL = process.env.REACT_APP_ENV_LEVEL;
export const FB_APP_ID = process.env.REACT_APP_FB_APP_ID;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const SERP_RESULTS_LIMIT = process.env.REACT_APP_SERP_RESULTS_LIMIT;
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLICK_KEY;